import axios from "axios";

// const base_url = "http://localhost:5003/api";
const base_url = "https://serve.easwallet.com/api";

export const apiClient = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const adminLogin = async (email, password) => {
  try {
    const payload = { email, password};
    const response = await apiClient.post("/mtrade/auth/admin/login", payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const createUser = async (email, password,) => {
  try {
    const payload = { email, password };

    const response = await apiClient.post(
      "/mtrade/auth/admin/create-sub-admin",
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getUsers = async () => {
  try{
  const res = await apiClient.get("/mtrade/users");
  return res.data;
 } catch (error) {
    console.error("Error fetching users: ", error.response?.data || error.message);
    throw error;
  }
};

export const getUser = async () => {
  try{
  const res = await apiClient.get("/mtrade/auth/me");
  return res.data;
 } catch (error) {
    console.error("Error fetching profile: ", error.response?.data || error.message);
    throw error;
  }
};

export const updateProfile = async (formData) => {
  try {
    const res = await apiClient.patch(`/mtrade/auth/update-profile`, formData, {
      headers: {
        // Essential for file uploads via FormData
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Profile update API error:", error.response?.data || error.message);
    throw error;
  }
};

export const updateKYCProfile = async (formData) => {
  try {
    const res = await apiClient.patch(`/mtrade/user/kyc-profile`, formData, {
      headers: {
        // Essential for file uploads via FormData
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Profile and KYC update API error:", error.response?.data || error.message);
    throw error;
  }
};

// Get user wallet
export const getUsersWallet = async () => {
  try {
     const res = await apiClient.get("/mtrade/get-wallet");
     return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};


export const submitSellProof = async (payload) => {
  try {
    const res = await apiClient.post("/mtrade/trade/proof", payload);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to submit trade proof:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getBanks = async () => {
  try {
    const res = await apiClient.get(`/mtrade/get-banks`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch banks:", error.response?.data || error.message);
    throw error;
  }
};

export const verifyAccount = async (accountNumber, bankCode) => {
  try {
    const res = await apiClient.post(`/mtrade/verify-account`, {accountNumber, bankCode});
    return res.data;
  } catch (error) {
    console.log("Failed to fetch banks:", error.response?.data || error.message);
    throw error;
  }
};

export const withdrawCryptoAPI = async (payload) => {
  try {
    const res = await apiClient.post(`/mtrade/withdraw`, payload);
    return res.data;
  } catch (error) {
    console.log("Failed withdraw crypto:", error.response?.data || error.message);
    throw error;
  }
};

export const getAssets = async () => {
  try {
    const res = await apiClient.get(`/mtrade/admin/assets`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch assets:", error.response?.data || error.message);
    throw error;
  }
};

export const addAdminCurrency = async (payload) => {
  // payload: { symbol, network, contractAddress, decimals }
  const res = await apiClient.post("/mtrade/admin/currencies", payload);
  return res.data;
};

export const updateAsset = async (id, payload) => {
  const res = await apiClient.patch(`/mtrade/admin/currencies/${id}`, payload);
  return res.data;
};

export const deleteAdminCurrency = async (id, hard = false) => {
  const res = await apiClient.delete(`/mtrade/admin/currencies/${id}?hard=${hard}`);
  return res.data;
};

export const syncAssetPrices = async () => {
  const res = await apiClient.get("/mtrade/admin/currencies/sync-prices");
  return res.data;
};


export const getAllTransactions = async () => {
  try {
    const res = await apiClient.get(`/mtrade/admin/transactions/all`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transactions:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllUserTransactions = async (userId) => {
  try {
    const res = await apiClient.get(`/mtrade/admin/transactions/user/${userId}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transactions:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllSubmittedKYC = async () => {
  try {
    const res = await apiClient.get(`/mtrade/admin/users-kyc`);
    return res.data;
  } catch (error) {
    console.log("Failed to get kyc:", error.response?.data || error.message);
    throw error;
  }
};

export const processKYC = async (userId, status) => {
  try {
    const response = await apiClient.post(`/mtrade/admin/kyc/process/${userId}`, { status });
    return response.data;
  } catch (error) {
    console.log("Failed to process kyc:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllWallet = async () => {
  try {
    const response = await apiClient.get(`/mtrade/get-all-wallet`);
    return response.data;
  } catch (error) {
    console.log("Failed to users wallet:", error.response?.data || error.message);
    throw error;
  }
};


// ── System Config (Admin) ─────────────────────────────────────

export const getSystemConfig = async (group = "") => {
  try {
    const url = group
      ? `/mtrade/admin/config?group=${group}`
      : `/mtrade/admin/config`;
    const res = await apiClient.get(url);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch config:", error.response?.data || error.message);
    throw error;
  }
};

export const updateSystemConfig = async (key, value) => {
  try {
    const res = await apiClient.patch(
      `/mtrade/admin/config/${encodeURIComponent(key)}`,
      { value }
    );
    return res.data;
  } catch (error) {
    console.log("Failed to update config:", error.response?.data || error.message);
    throw error;
  }
};

export const bulkUpdateSystemConfig = async (settings) => {
  // settings = [{ key, value }, { key, value }, ...]
  try {
    const res = await apiClient.patch(`/mtrade/admin/config`, { settings });
    return res.data;
  } catch (error) {
    console.log("Failed to bulk update config:", error.response?.data || error.message);
    throw error;
  }
};

export const resetConfigGroup = async (group) => {
  try {
    const res = await apiClient.post(`/mtrade/admin/config/reset/${group}`);
    return res.data;
  } catch (error) {
    console.log("Failed to reset config group:", error.response?.data || error.message);
    throw error;
  }
};


export const getRewardStats = async () => {
  try {
    const res = await apiClient.get(`/mtrade/admin/rewards/stats`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch reward stats:", error.response?.data || error.message);
    throw error;
  }
};

export const grantAdminBonus = async (userId, amount, description) => {
  try {
    const res = await apiClient.post(`/mtrade/admin/rewards/bonus`, {
      userId,
      amount,
      description,
    });
    return res.data;
  } catch (error) {
    console.log("Failed to grant bonus:", error.response?.data || error.message);
    throw error;
  }
};

export const sendAdminNotification = async (payload) => {
  // payload: { title, body, type, click_action, target }
  try {
    const res = await apiClient.post("/mtrade/admin/notifications/send", payload);
    return res.data;
  } catch (error) {
    console.log("Failed to send notification:", error.response?.data || error.message);
    throw error;
  }
};

export const getAdminNotificationHistory = async (page = 1) => {
  try {
    const res = await apiClient.get(`/mtrade/admin/notifications/history?page=${page}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch notification history:", error.response?.data || error.message);
    throw error;
  }
};

export const searchUsersForNotification = async (search = "") => {
  try {
    const res = await apiClient.get(`/mtrade/admin/notifications/users?search=${encodeURIComponent(search)}`);
    return res.data;
  } catch (error) {
    console.log("Failed to search users:", error.response?.data || error.message);
    throw error;
  }
};


export const getAdminUsers = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await apiClient.get(`/mtrade/admin/users?${query}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch users:", error.response?.data || error.message);
    throw error;
  }
};

export const getAdminUserDetail = async (userId) => {
  try {
    const res = await apiClient.get(`/mtrade/admin/users/${userId}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch user detail:", error.response?.data || error.message);
    throw error;
  }
};

export const getAdminUserTransactions = async (userId, page = 1) => {
  try {
    const res = await apiClient.get(`/mtrade/admin/users/${userId}/transactions?page=${page}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch user transactions:", error.response?.data || error.message);
    throw error;
  }
};

export const suspendUser = async (userId, reason = "") => {
  try {
    const res = await apiClient.patch(`/mtrade/admin/users/${userId}/suspend`, { reason });
    return res.data;
  } catch (error) {
    console.log("Failed to suspend user:", error.response?.data || error.message);
    throw error;
  }
};

export const unsuspendUser = async (userId) => {
  try {
    const res = await apiClient.patch(`/mtrade/admin/users/${userId}/unsuspend`);
    return res.data;
  } catch (error) {
    console.log("Failed to unsuspend user:", error.response?.data || error.message);
    throw error;
  }
};

export const adjustUserBalance = async (userId, amount, type, note = "") => {
  try {
    const res = await apiClient.patch(`/mtrade/admin/users/${userId}/adjust-balance`, {
      amount, type, note,
    });
    return res.data;
  } catch (error) {
    console.log("Failed to adjust balance:", error.response?.data || error.message);
    throw error;
  }
};

// ── Admin Transaction Management ─────────────────────────────

export const getAdminTransactions = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await apiClient.get(`/mtrade/admin/transactions?${query}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transactions:", error.response?.data || error.message);
    throw error;
  }
};

export const getAdminTransactionDetail = async (txId) => {
  try {
    const res = await apiClient.get(`/mtrade/admin/transactions/${txId}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transaction detail:", error.response?.data || error.message);
    throw error;
  }
};

export const updateAdminTransactionStatus = async (txId, status, note = "") => {
  try {
    const res = await apiClient.patch(`/mtrade/admin/transactions/${txId}/status`, { status, note });
    return res.data;
  } catch (error) {
    console.log("Failed to update transaction status:", error.response?.data || error.message);
    throw error;
  }
};

export const getAdminTransactionOverview = async () => {
  try {
    const res = await apiClient.get("/mtrade/admin/transactions/overview");
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transaction overview:", error.response?.data || error.message);
    throw error;
  }
};

// ── Admin Wallet Management ───────────────────────────────────

export const getAdminWallets = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await apiClient.get(`/mtrade/admin/wallets?${query}`);
  return res.data;
};

export const getAdminWalletStats = async () => {
  const res = await apiClient.get("/mtrade/admin/wallets/stats");
  return res.data;
};

export const getAdminWalletDetail = async (userId) => {
  const res = await apiClient.get(`/mtrade/admin/wallets/${userId}`);
  return res.data;
};

export const refreshWalletBalances = async (userId) => {
  const res = await apiClient.post(`/mtrade/admin/wallets/${userId}/refresh-balances`);
  return res.data;
};

export const adjustNairaBalance = async (userId, amount, type, note = "") => {
  const res = await apiClient.patch(`/mtrade/admin/wallets/${userId}/naira`, { amount, type, note });
  return res.data;
};

export const adjustCryptoBalance = async (userId, network, currency, balance, note = "") => {
  const res = await apiClient.patch(`/mtrade/admin/wallets/${userId}/crypto`, { network, currency, balance, note });
  return res.data;
};

export const regenerateUserWallet = async (userId) => {
  const res = await apiClient.post(`/mtrade/admin/wallets/${userId}/regenerate`);
  return res.data;
};

export const regenerateAllWallets = async () => {
  const res = await apiClient.post("/mtrade/admin/wallets/regenerate-all");
  return res.data;
};

export const clearStuckLock = async (userId, network = "") => {
  const res = await apiClient.delete(`/mtrade/admin/wallets/${userId}/stuck-lock`, {
    data: network ? { network } : {},
  });
  return res.data;
};

export const getAdminUserWalletTxns = async (userId, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await apiClient.get(`/mtrade/admin/wallets/${userId}/transactions?${query}`);
  return res.data;
};


// ── App Settings (Admin) ──────────────────────────────────────

export const getAdminBranding    = async ()      => (await apiClient.get("/mtrade/admin/app-settings/branding")).data;
export const updateAdminBranding = async (data)  => (await apiClient.patch("/mtrade/admin/app-settings/branding", data)).data;

export const getAdminContact     = async ()      => (await apiClient.get("/mtrade/admin/app-settings/contact")).data;
export const updateAdminContact  = async (data)  => (await apiClient.patch("/mtrade/admin/app-settings/contact", data)).data;

export const getAdminLegal       = async ()      => (await apiClient.get("/mtrade/admin/app-settings/legal")).data;
export const updateAdminLegal    = async (data)  => (await apiClient.patch("/mtrade/admin/app-settings/legal", data)).data;

export const getAdminFAQs        = async (params = {}) => {
  const q = new URLSearchParams({ includeInactive: "true", ...params }).toString();
  return (await apiClient.get(`/mtrade/admin/app-settings/faq?${q}`)).data;
};
export const createAdminFAQ      = async (data)  => (await apiClient.post("/mtrade/admin/app-settings/faq", data)).data;
export const updateAdminFAQ      = async (id, data) => (await apiClient.patch(`/mtrade/admin/app-settings/faq/${id}`, data)).data;
export const deleteAdminFAQ      = async (id)    => (await apiClient.delete(`/mtrade/admin/app-settings/faq/${id}`)).data;
export const reorderAdminFAQs    = async (order) => (await apiClient.patch("/mtrade/admin/app-settings/faq/reorder", { order })).data;


export const getAdminServices   = async () => (await apiClient.get("/mtrade/admin/services")).data;
export const updateAdminService = async (key, data) => (await apiClient.patch(`/mtrade/admin/services/${key}`, data)).data;
export const toggleAllServices  = async (enabled) => (await apiClient.patch("/mtrade/admin/services/toggle-all", { enabled })).data;

export const getAdminOnboardingSlides = async () => (await apiClient.get("/mtrade/admin/onboarding/slides")).data;
export const createAdminOnboardingSlide = async (d) => (await apiClient.post("/mtrade/admin/onboarding/slides", d)).data;
export const updateAdminOnboardingSlide = async (id, d) => (await apiClient.patch(`/mtrade/admin/onboarding/slides/${id}`, d)).data;
export const deleteAdminOnboardingSlide = async (id) => (await apiClient.delete(`/mtrade/admin/onboarding/slides/${id}`)).data;
export const reorderAdminOnboardingSlides = async (order) => (await apiClient.patch("/mtrade/admin/onboarding/slides/reorder", { order })).data;


export const getAdminAccounts        = async ()         => (await apiClient.get("/mtrade/admin/accounts")).data;
export const createAdminAccount      = async (data)     => (await apiClient.post("/mtrade/admin/accounts", data)).data;
export const updateAdminAccount      = async (id, data) => (await apiClient.patch(`/mtrade/admin/accounts/${id}`, data)).data;
export const resetAdminAccountPass   = async (id, pwd)  => (await apiClient.patch(`/mtrade/admin/accounts/${id}/password`, { newPassword: pwd })).data;
export const deactivateAdminAccount  = async (id)       => (await apiClient.delete(`/mtrade/admin/accounts/${id}`)).data;



export const getAdminAlerts        = async ()         => (await apiClient.get("/mtrade/admin/alerts")).data;
export const dismissAdminAlert      = async (data)     => (await apiClient.patch("/mtrade/admin/alerts/dismiss-all")).data;
export const dismissAllAdminAlerts      = async (id, data) => (await apiClient.patch(`/mtrade/admin/alerts/${id}/read`, data)).data;
export const markAdminAlertRead   = async (id, pwd)  => (await apiClient.patch(`/mtrade/admin/alerts/${id}/dismiss`)).data;

export const getVTUProvider    = async ()           => (await apiClient.get("/mtrade/admin/vtu/provider")).data;
export const setVTUProvider = (data) =>
  apiClient.post("/mtrade/admin/vtu/provider", data);
export const testVTUProvider   = async ()           => (await apiClient.get("/mtrade/admin/vtu/provider/test")).data;



// ─────────────────────────────────────────────────────────────
// ADD to adminApiServices.js
// ─────────────────────────────────────────────────────────────

// ── Provider & gateway balances ───────────────────────────────
export const getProviderBalances = async () => {
  const res = await apiClient.get("/mtrade/admin/provider-balances");
  return res.data;
};

export const refreshProviderBalance = async (name) => {
  const res = await apiClient.get(`/mtrade/admin/provider-balances/${name}`);
  return res.data;
};

export const setProviderThreshold = async (name, amount) => {
  const res = await apiClient.patch(`/mtrade/admin/provider-balances/${name}/threshold`, { amount });
  return res.data;
};

// ── Gateway routing ─────────────────────────────────────────
export const getGatewayStatus = async () => {
  const res = await apiClient.get("/mtrade/admin/gateways");
  return res.data;
};

export const switchGateway = async (service, gateway) => {
  const res = await apiClient.post("/mtrade/admin/gateways/switch", { service, gateway });
  return res.data;
};

export const testGateway = async (gateway) => {
  const res = await apiClient.post(`/mtrade/admin/gateways/test/${gateway}`);
  return res.data;
};

export const enableGateway = async (gateway) => {
  const res = await apiClient.post(`/mtrade/admin/gateways/${gateway}/enable`);
  return res.data;
};

export const disableGateway = async (gateway) => {
  const res = await apiClient.post(`/mtrade/admin/gateways/${gateway}/disable`);
  return res.data;
};

export const getAppVersion = async () => {
  const res = await apiClient.get(`/mtrade/admin/app-version`);
  return res.data;
};

export const updateAppVersion = async (platform, body) => {
  const res = await apiClient.put(`/mtrade/admin/app-version/${platform}`, body);
  return res.data;
};
// ── Service per-country / per-user controls ───────────────────
export const addServiceDisabledUser = async (serviceKey, userId) =>
  (await apiClient.post(`/mtrade/admin/services/${serviceKey}/disable-user`, { userId })).data;

export const removeServiceDisabledUser = async (serviceKey, userId) =>
  (await apiClient.delete(`/mtrade/admin/services/${serviceKey}/disable-user`, { data: { userId } })).data;

export const updateServiceCountries = async (serviceKey, { allowedCountries, disabledCountries }) =>
  (await apiClient.patch(`/mtrade/admin/services/${serviceKey}`, { allowedCountries, disabledCountries })).data;

// ── Country management ────────────────────────────────────────
export const getAdminCountries     = async ()                   => (await apiClient.get("/mtrade/admin/countries")).data;
export const getAdminCountry       = async (code)               => (await apiClient.get(`/mtrade/admin/countries/${code}`)).data;
export const addAdminCountry       = async (body)               => (await apiClient.post("/mtrade/admin/countries", body)).data;
export const updateAdminCountry    = async (code, body)         => (await apiClient.patch(`/mtrade/admin/countries/${code}`, body)).data;
export const toggleAdminCountry    = async (code)               => (await apiClient.patch(`/mtrade/admin/countries/${code}/toggle`)).data;
export const deleteAdminCountry    = async (code)               => (await apiClient.delete(`/mtrade/admin/countries/${code}`)).data;

export const deleteAdminUser = (userId) =>
  apiClient.delete(`/mtrade/admin/users/${userId}/delete`, { data: { confirm: true } }).then(r => r.data);